import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-mob-window" }
const _hoisted_2 = {
  key: 0,
  class: "list-mob-window__wrapper"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "list-mob-window__item-header" }
const _hoisted_5 = { class: "list-mob-window__item-header-title" }
const _hoisted_6 = { class: "list-mob-window__item-header-title-hl" }
const _hoisted_7 = { class: "list-mob-window__item-header-address" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "list-mob-window__item-body custom-list-mob" }
const _hoisted_12 = {
  key: 0,
  class: "custom-list-mob__item"
}
const _hoisted_13 = { class: "custom-list-mob__item-value" }
const _hoisted_14 = { class: "custom-list-mob__item" }
const _hoisted_15 = { class: "custom-list-mob__item-value" }
const _hoisted_16 = {
  key: 1,
  class: "custom-list-mob__item"
}
const _hoisted_17 = { class: "custom-list-mob__item-value" }
const _hoisted_18 = { class: "list-mob-window__item-price" }
const _hoisted_19 = {
  key: 0,
  class: "list-mob-window__item-price-set"
}
const _hoisted_20 = {
  key: 0,
  class: "list-mob-window__item-price-set"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "list-mob-window__item-price-set"
}
const _hoisted_24 = { class: "list-mob-window__item-price-value" }
const _hoisted_25 = {
  key: 1,
  class: "list-mob-window__void"
}

import { computed } from 'vue';
    import ModalTemplate from '@/components/layouts/ModalTemplate.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { cashSpacer } from '@/helpers/cashHelpers';
    import { switchCostLabel } from '@/helpers/costHelpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ListMobWindow',
  emits: ['close', 'openInDetailCardWindow', 'openList'],
  setup(__props, { emit: __emit }) {

    const emits = __emit;

    const landPlotList = computed(() => {
        return landPlotStore.CURRENT_FILTERED_LAND_PLOTS;
    });

    function blackBoxPrice(index: number) {
        return landPlotList.value[index].plot.cost;
    }

    function whiteBoxPrice(index: number) {
        return landPlotList.value[index].plot.newCost;
    }

    const isSold = (index: number) => {
        const card = landPlotList.value[index].plot;

        return (!card?.cost && !card?.newCost) || card.status === 'occupied';
    };

    function price(data: number) {
        return cashSpacer(data, ' ');
    }

    async function openInDetailCardWindow(data: number | string) {
        emits('close');
        await landPlotStore.CREATE_LAND_PLOT_CARD_IN_MODAL(data);
        cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(true);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    onOpenList: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openList'))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    closeBtn: true,
    scrollBodyLock: true,
    mode: "list"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (landPlotList.value && landPlotList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(landPlotList.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-mob-window__item",
                  key: `list-mob-window-item-${item.id}`,
                  onClick: ($event: any) => (openInDetailCardWindow(item.plot.number))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.house ? item.plot.name : 'Участок'), 1),
                      _cache[2] || (_cache[2] = _createTextVNode(", ")),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.plot.street.name) + ", " + _toDisplayString(item.plot.houseNumber), 1)
                    ])
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["list-mob-window__item-header-status", `list-mob-window__item-header-status--${item.plot.status}`])
                  }, [
                    (item.plot.status === 'free')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Свободен "))
                      : (item.plot.status === 'booked')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Забронирован "))
                        : (item.plot.status === 'occupied')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Занят "))
                          : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_11, [
                    (item.house)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "custom-list-mob__item-name" }, " Площадь дома, м2 ", -1)),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(item.house.area), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "custom-list-mob__item-name" }, " Площадь участка, соток ", -1)),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(item.plot.area), 1)
                    ]),
                    (item.house && item.plot.parameters.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "custom-list-mob__item-name" }, " Сроки сдачи ", -1)),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(item.plot.parameters[0].value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (isSold(i))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[6] || (_cache[6] = [
                          _createElementVNode("div", { class: "list-mob-window__item-price-value list-mob-window__item-price-value--sold" }, " Продано ", -1)
                        ])))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (blackBoxPrice(i))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", {
                                  class: "list-mob-window__item-price-label",
                                  innerHTML: 
                                        `Цена с ${_unref(switchCostLabel)(
                                            blackBoxPrice(i),
                                            [
                                                `<b
                                >чистовой отделкой</b
                            >`,
                                                `отделкой <b>Black box</b>`,
                                            ],
                                        )}`
                                    
                                }, null, 8, _hoisted_21),
                                _createElementVNode("div", {
                                  class: "list-mob-window__item-price-value",
                                  innerHTML: 
                                        `Цена с ${_unref(switchCostLabel)(
                                            blackBoxPrice(i),
                                            [
                                                `<b
                                >чистовой отделкой</b
                            >`,
                                                `отделкой <b>White box</b>`,
                                            ],
                                        )}`
                                    
                                }, null, 8, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true),
                          (whiteBoxPrice(i))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "list-mob-window__item-price-label" }, [
                                  _createTextVNode(" Цена от с отделкой "),
                                  _createElementVNode("b", null, "White box")
                                ], -1)),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(price(whiteBoxPrice(i) ?? 0)) + " ₽ ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ])
                ], 8, _hoisted_3))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[8] || (_cache[8] = [
              _createElementVNode("p", { class: "list-mob-window__void-text" }, "Не найдено участков", -1)
            ])))
      ])
    ]),
    _: 1
  }))
}
}

})